import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import ModelCard from './components/ModelCard';
import Login from './components/Login';
import { useAuth } from './contexts/AuthContext';

function App() {
  const { user, login, verifyUser, isLoading: authLoading } = useAuth();
  const [models, setModels] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredModels, setFilteredModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Carrega os modelos do arquivo JSON dinamicamente
    fetch('/models.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao carregar os modelos');
        }
        return response.json();
      })
      .then(data => {
        setModels(data);
        setFilteredModels(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erro ao carregar modelos:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // Filtra os modelos baseado no termo de busca
    if (searchTerm.trim() === '') {
      setFilteredModels(models);
    } else {
      const filtered = models.filter(model =>
        model.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        model.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredModels(filtered);
    }
  }, [searchTerm, models]);

  // Mostrar tela de login se não estiver autenticado
  if (authLoading) {
    return (
      <div className="App">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={login} onToken={verifyUser} />;
  }

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <SearchBar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
        
        {loading ? (
          <div className="loading">
            <div className="loading-spinner"></div>
            <p className="loading-text">Carregando modelos...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <svg className="error-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="error-title">Erro ao carregar modelos</h2>
            <p className="error-text">{error}</p>
          </div>
        ) : filteredModels.length > 0 ? (
          <div className="models-grid">
            {filteredModels.map(model => (
              <ModelCard key={model.id} model={model} />
            ))}
          </div>
        ) : (
          <div className="no-results">
            <svg className="no-results-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="no-results-title">Nenhum modelo encontrado</h2>
            <p className="no-results-text">Tente buscar por outro termo</p>
          </div>
        )}
      </main>
      
      <footer className="footer">
        <p>© 2026 OSGENIUS - Ferramentas 3D. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default App;
